/**
 * @file
 * Stats script.
 */

(function statsScript($, Drupal, countUp) {
  'use strict';

  /*
   * Stat Graphics.
   */
  Drupal.behaviors.statGraphics = {
    attach: function (context) {
      // Utility to get a number to a place (10th, 100th, etc).
      function numberPlace(number, increment) {
        return number % increment;
      }

      // Draw a radial graphic.
      function drawRadialGraphic(canvas, value) {
        if (canvas[0].getContext) {
          var ctx = canvas[0].getContext('2d');
          var percent;
          var degree;
          var radian;

          // Punch out the center to make the radial shape.
          ctx.fillStyle = '#fff';
          ctx.beginPath();
          ctx.arc(500, 500, 250, 0, Math.PI * 2, true);
          ctx.closePath();
          ctx.fill();

          // We can only show the amount over 100% since that's the scale
          // we have to work with in a radial representation.
          // For example 368% will be represented as 68%.
          if (value > 100) {
            // Get below the 100th place value.
            value = numberPlace(value, 100);
            // Turn to percentage.
            percent = value / 100;
            // Then to degrees.
            degree = percent * 360.0;
            // Then to radians.
            radian = degree * (Math.PI / 180);

            // Draw the stroke overlay.
            ctx.strokeStyle = 'rgba(255, 255, 255, .65)';
            ctx.beginPath();
            ctx.lineWidth = 500;
            ctx.arc(500, 500, 500, -0.5 * Math.PI, radian + (-0.5 * Math.PI), true);
            ctx.stroke();
          }
          else {
            // Turn to percentage.
            percent = value / 100;
            // Then to degrees.
            degree = percent * 360.0;
            // Then to radians.
            radian = degree * (Math.PI / 180);

            // Draw the stroke overlay.
            ctx.strokeStyle = 'rgba(255, 255, 255, .65)';
            ctx.beginPath();
            ctx.lineWidth = 500;
            ctx.arc(500, 500, 500, -0.5 * Math.PI, radian + (-0.5 * Math.PI), true);
            ctx.stroke();
          }
        }
      }

      // Draw a circle-on-circle graphic.
      function drawCircleOnCircleGraphic(canvas, value) {
        if (canvas[0].getContext) {
          var ctx = canvas[0].getContext('2d');
          var increase;
          var radius;
          var y;

          // We are greatly simplifying here to give a graphical represention
          // of the increase but keep it visible and have it mean something.
          //
          // If a large enough number, over 250, bring it down by 10x.
          // If after rounding it is still over 25, bring it down again.
          if (value >= 250) {
            value = value / 100;
            increase = Math.round(value);
            if (increase > 25) {
              increase = increase / 10;
            }
          }
          // If a small number, show as it is.
          else if (value <= 25) {
            increase = value;
          }
          // Everything else, round it and bring it down by 10x.
          else {
            increase = Math.round(value);
            if (increase > 25) {
              increase = increase / 10;
            }
          }

          // The radius is using a 1000px canvas, so divide
          //  by the increase, rounding, and divide again by 2.
          radius = Math.round(1000 / increase) / 2;
          // Position centered on the y-axis.
          y = 1000 - radius;

          // Draw the circle, positioning it at the bottom center of the canvas.
          ctx.fillStyle = 'rgba(255, 255, 255, .65)';
          ctx.beginPath();
          ctx.arc(500, y, radius, 0, Math.PI * 2, true);
          ctx.closePath();
          ctx.fill();
        }
      }

      $('.stats--infographic .stat', context).each(function (index) {
        var $stat = $(this);
        var $canvas = $('.stat__graphic', $stat);
        var type = $canvas.attr('data-stat-graphic');
        var value = $canvas.attr('data-stat-value');

        switch (type) {
          case 'radial':
            drawRadialGraphic($canvas, value);
            break;

          case 'circle-on-circle':
            drawCircleOnCircleGraphic($canvas, value);
            break;
        }
      });
    }
  };

  /*
   * Stat Numbers.
   */
  Drupal.behaviors.statNumbers = {
    attach: function (context) {
      // Count up the stats.
      // Docs: https://inorganik.github.io/countUp.js
      $('.stats--numbers .stat.u-count-up', context).each(function (index) {
        var $stat = $(this);
        var statStart = $stat.attr('data-countup-start');
        var statEnd = $stat.attr('data-countup-end');
        var statPrefix = $('.stat__prefix', $stat).text();
        var statPrefixHtml = '<span class="stat__prefix">' + statPrefix + '</span>';
        var statSuffix = $('.stat__suffix', $stat).text();
        var statSuffixHtml = '<span class="stat__suffix">' + statSuffix + '</span>';
        var statValue = $('.stat__value', $stat)[0];
        // This was hardcoded to '0'. Replaced with variable that will be
        // modified based on following conditions.
        var statDecimalCount = 0;
        // We do the following to ensure that there is a non <div> child
        // that is a pure integer, since that is what our current countUp
        // implementation requires.
        var validStatValue = false;
        $(statValue).contents().each(function () {
          var $statValueText = $(this).text().trim();
          // Check that we're on a text node and that it only has digits.
          if (this.nodeType === 3 && !!$statValueText.match(/^\d+[.,]?\d+$/)) {
            // Check that a decimal does exist.
            if ($statValueText.indexOf('.') !== -1) {
              // Get number of decimal places in number.
              statDecimalCount = $statValueText.split('.')[1].length;
            }
            validStatValue = true;
            return false; // breaks out of .each()
          }
        });

        // Seconds from start to finish of animation
        var duration = 1;
        var countUpOptions = {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          prefix: statPrefix ? statPrefixHtml : '',
          suffix: statSuffix ? statSuffixHtml : ''
        };
        if (validStatValue) {
          // This is a valid stat value. Create a CountUp instance and bind it.
          var statCountUp = new countUp.CountUp(statValue, statStart, statEnd, statDecimalCount, duration, countUpOptions);
          // Execute `$('.stats-numbers .stat').trigger('anim-trigger')` to start.
          // Done in `animations.js` as part of a staggered start.
          $stat.on('anim-trigger', function () {
            statCountUp.start();
          });
        }
      });
    }
  };
}(jQuery, Drupal, countUp));
